const wx = wx || window.wx;

const successFunction = () => {
	// 设置成功
}
const cancel = () => {}

import apiAxios from "../fetch/api.js"

const wx_share = config => {
	const title = config.title || "GE AND ME实验室全职高手征文大赛", // 分享标题
		desc = config.desc || "GE AND ME实验室全职高手征文大赛", // 分享描述
		link = config.link || "http://customer.medsci.cn/project/activity/dist/index.html#/", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
		imgUrl = config.imgUrl || "http://customer.medsci.cn/project/activity/dist/icons.png", // 分享图标
		type = config.type || "", // 分享类型,music、video或link，不填默认为link
		dataUrl = config.dataUrl || ""; // 如果type是music或video，则要提供数据链接，默认为空
	
	if (wx && wx.config) {
		apiAxios('GET', 'share_api', {
			url: window.location.href
		}).then(resp => {
			wx.config(resp.data);
		}).catch(() => {});
		wx.ready(function () {
			/**
			 * config信息验证后会执行ready方法， 所有接口调用都必须在config接口获得结果之后， config是一个客户端的异步操作， 所以如果需要在页面加载时就调用相关接口
			 * 则须把相关接口放在ready函数中调用来确保正确执行。 对于用户触发时才调用的接口， 则可以直接调用， 不需要放在ready函数中。
			 */

			// “分享给朋友”及“分享到QQ”
			wx.updateAppMessageShareData({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				success: successFunction
			});
			// 分享到朋友圈”及“分享到QQ空间
			wx.updateTimelineShareData({
				title: title,
				link: link,
				imgUrl: imgUrl,
				success: successFunction
			});
			// 分享到朋友圈
			wx.onMenuShareTimeline({
				title: title,
				link: link,
				imgUrl: imgUrl,
				success: successFunction
			});
			// 分享给朋友
			wx.onMenuShareAppMessage({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				type: type,
				dataUrl: dataUrl,
				success: successFunction
			});
			// 分享到QQ
			wx.onMenuShareQQ({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				success: successFunction,
				cancel: cancel
			});
			// 分享到腾讯微博
			wx.onMenuShareWeibo({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				success: successFunction,
				cancel: cancel
			});
			// 分享到QQ空间
			wx.onMenuShareQZone({
				title: title,
				desc: desc,
				link: link,
				imgUrl: imgUrl,
				success: successFunction,
				cancel: cancel
			})

		});
	}
}

export default wx_share;